module.exports = __webpack_public_path__ + "static/media/P40.e4671766.png";